//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '../../../src/lib/date';

export default {
    name: 'contentList',
    data() {
        const vm = this;
        return {
            loading: false,
            nodeId: 0,
            nodeName: '',
            isAdd: false,
            saving: false,
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '标题',
                    key: 'title',align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('a', {
                            on: {
                                click() {
                                    vm.showContentInfo(row);
                                }
                            }
                        }, row.title));
                        return h('div', actions);
                    }
                },
                {
                    title: '类型',align: 'center',
                    key: 'contentTypeStr'
                },
                {
                    title: '作者',align: 'center',
                    key: 'author'
                },
                {
                    title: '来源',align: 'center',
                    key: 'source'
                },
                {
                    title: '创建时间',align: 'center',
                    key: 'creationTimeStr'
                },
                {
                    title: '发布状态',align: 'center',
                    key: 'releaseStatusStr'
                },
              {
                title: '排序',key:'sort',
                align: 'center'
              },
            ]
        };
    },
    filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    methods: {
        getNodeList() {
            this.loading = true;
            this.$store.dispatch({
                type: 'node/getAllNodes'
            }).finally(() => {
                this.loading = false;
            });
        },
        selectChange(data) {
            // console.log(data);
            this.nodeId = 0;
            this.nodeName = '';
            if (data.length > 0) {
                this.nodeId = data[0].id;
                this.nodeName = data[0].nodeName;
                this.pageChange(1);
            }
            // console.log(this.nodeId);
            if (this.nodeId != 0) {
                this.isAdd = true;
            } else {
                this.isAdd = false;
            }
        },
        pageChange(page) {
            this.$store.commit('content/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChange(pageSize) {
            this.$store.commit('content/setPageSize', pageSize);
            this.getPage();
        },
        getPage() {
            this.loading = true;
            this.$store.dispatch({
                type: 'content/getAll',
                data: {
                    nodeId: this.nodeId
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        delContent(content) {
            this.saving = true;
            this.$store.dispatch({
                type: 'content/delContent',
                id: content.id
            }).then(() => {
                this.$Notice.success({
                    duration: 3,
                    title: content.title + '已删除'
                });
                // this.getNodeList();
                this.getPage();
            }, (error) => {
                this.$Modal.error({
                    title: '删除提示'
                });
                this.$Message.destroy();
            }).finally(() => {
                this.saving = false;
            });
        },
        addContent(id) {
            this.$router.push({
                path: '/contentEdit/' + id
            });
        },
        editContent(content) {
            var id = content.id;
            var nodeName = this.nodeName;
            var nodeId = content.nodeId;
            this.$router.push('/contentEdit/' + content.id);
        },
        changStatus(id, status) {
            this.saving = true;
            this.content = {};
            abp.ajax.post('/api/services/app/Content/ChangeStatus', {
                id: id,
                status: status
            })
                .then(() => {
                    this.getPage();
                }).finally(() => {
                this.saving = false;
            });
        },
        showContentInfo(content) {
            this.$router.push('/contentInfo/' + content.id);
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.getNodeList();
        this.getPage();
    },
    computed: {
        nodeList() {
            return this.$store.state.node.nodes;
        },
        contents() {
            return this.$store.state.content.contents;
        },
        totalCount() {
            return this.$store.state.content.totalCount;
        },
        currentPage() {
            return this.$store.state.content.currentPage;
        },
        pageSize() {
            return this.$store.state.content.pageSize;
        }
    },
    watch: {}
};
